export const COMPARE_PERIODS = {
  previousPeriod: "PreviousPeriod",
  previousYear: "PreviousYear",
};
